import * as Sentry from '@sentry/react'
import { isChunkLoadError } from './helper'

export default () => {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      release: `${import.meta.env.PACKAGE_NAME}@${import.meta.env.PACKAGE_VERSION}`,
      normalizeDepth: 5,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'Cannot redefine property: googletag',
        'ResizeObserver loop completed with undelivered notifications',
        'Unexpected token _ in JSON at position 0',
        'SecurityError: The operation is insecure.',
        'OneSignal is already initialized.',
        'OneSignal script failed to load.',
        'This browser does not support Web Push notifications.',
        'QuotaExceededError: The quota has been exceeded.',
        "TypeError: crypto.randomUUID is not a function. (In 'crypto.randomUUID()', 'crypto.randomUUID' is undefined)",
        /Loading (?:CSS )?chunk \d+ failed/i,
        /Failed to fetch dynamically imported module/i,
        /error loading dynamically imported module/i,
        /Importing a module script failed/i,
        /Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node./i,
        /Unable to preload CSS/,
        /Cannot read properties of null (reading 'style')/,
      ],
      beforeSend(event, hint) {
        const err = hint?.originalException || hint?.syntheticException
        const msg = String(err?.message || event?.message || '')

        // Group error chunk mismatch biar gak spam
        if (isChunkLoadError(err)) {
          event.fingerprint = ['chunk-mismatch']
        }

        // Drop sebagian error saat offline
        if (!navigator.onLine && msg.includes('Failed to fetch')) {
          return null
        }

        // tag tambahan berguna
        event.tags = { ...(event.tags || {}), app_version: import.meta.env.VITE_VERSION }

        return event
      },
    })
  }
}

export const reportToSentry = ({
  message,
  context = { name: '', context: {} },
  level = 'warning',
  fingerprint,
}) => {
  if (!import.meta.env.VITE_SENTRY_DSN) {
    console.warn('[Sentry Report]', message, context)
    return
  }

  Sentry.withScope((scope) => {
    scope.setLevel(level)
    scope.setContext(context.name, context.context)
    // satukan laporan sejenis di satu issue Sentry
    if (fingerprint) {
      scope.setFingerprint(fingerprint)
    }

    Sentry.captureMessage(message)
  })
}
